/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsCommunityFundTotalMaturity } from "../../funcs/metricsGetApiV3MetricsCommunityFundTotalMaturity.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3MetricsCommunityFundTotalMaturityRequest$inboundSchema.optional(),
};

export const tool$metricsGetApiV3MetricsCommunityFundTotalMaturity:
  ToolDefinition<typeof args> = {
    name: "metrics-get-api-v3-metrics-community-fund-total-maturity",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await metricsGetApiV3MetricsCommunityFundTotalMaturity(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
